module.exports = __webpack_public_path__ + "img/outlined_icon.7355ffdd.svg";